function GitHubButton({link}) {

    return (
        <a href={link} target = "_blank" rel="noopener noreferrer"> {/*"remove targe and rel to keep it in the same page"*/}
            <button className="border border-gray-600 bg-[#1a1a1a] text-gray-200 hover:border-cyan-500 hover:text-cyan-400 px-5 py-2 rounded-full font-bold transition-colors duration-200">
                Launch Github Repo
            </button>
        </a>
    );
}

export default GitHubButton;
